import React from "react";

import { subscribeToBlockingRequests } from "../../../api/api";
import Loader from "../loader/Loader";

// api.js sets no axios timeout, so a socket that stalls without closing never
// settles. After this long the scrim hides itself anyway: a hung request is
// bad, a permanently unusable page is worse.
//
// This lives here, not in the api layer's count, on purpose. The count must
// stay truthful while the request is on the wire, because CommentForm's
// submit lock reads it -- releasing the count early would re-enable Save
// mid-request and reopen the duplicate-comment path.
export const OVERLAY_CEILING_MS = 30000;

/*
 * Covers the page while a write is in flight, so nothing can be clicked
 * before the server has answered. Pointer only: the keyboard can still reach
 * what is underneath (Esc closes a dialog, Tab reaches its links).
 *
 * Driven by the api layer's in-flight count rather than per-form state: a
 * saga that swallows its error cannot leave this stranded, and every write
 * is covered without each form having to remember to ask.
 *
 * Reuses .modal__overlay (styles/modal.scss) -- already a fixed, full
 * viewport, click-intercepting layer -- so this adds no CSS.
 */
export class BlockingOverlay extends React.Component {
  state = { blocked: false, expired: false };

  componentDidMount() {
    this.unsubscribe = subscribeToBlockingRequests((blocked) => {
      clearTimeout(this.ceiling);
      if (blocked) {
        this.ceiling = setTimeout(
          () => this.setState({ expired: true }),
          OVERLAY_CEILING_MS,
        );
      }
      this.setState({ blocked, expired: false });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    clearTimeout(this.ceiling);
  }

  render() {
    if (!this.state.blocked || this.state.expired) return null;

    return (
      <div
        className="modal__overlay"
        // .modal__overlay is z-index 100, and the slide-in dialogs are
        // react-modal portals appended to <body> after #root -- so at equal
        // z-index they win on DOM order and the editor stays clickable
        // underneath. 999 clears them while staying below the toaster (1000)
        // so an error message is still readable if one arrives mid-request.
        style={{ zIndex: 999 }}
        aria-busy="true"
        aria-live="polite"
      >
        <Loader />
      </div>
    );
  }
}

export default BlockingOverlay;
